
import {
  Stack,
  TableCell,
  TableRow,
  Typography,
  useTheme
} from '@mui/material';
import { DateTime } from 'luxon';
import React from 'react';
import { useNavigate } from 'react-router-dom';



export type DailyReportRowProps = {
  id: string;
  date: DateTime;
  description: string;
  fullAddress: string;
  approvedBy: string;
  approvedAt: string;
  subcontractors: number;
  events: {
    incidents: number;
    inspections: number;
    events: number;
    deliveries: number;
  };


};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: DailyReportRowProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <TableRow
      onClick={() => navigate(`${props.id}`)}
      content='list'
    >
      <TableCell
        variant='firstRounded'

      >
        <Typography
          variant='tableCellBold'
          color={theme.palette.primary.main}
        >

          {props.date.toFormat('LLL dd, yyyy')}
        </Typography>
      </TableCell>
      <TableCell
        variant='body'
      >
        <Stack
          direction='column'
        >
          <Typography
            variant='body1'
          >
            {props.description}
          </Typography>
        </Stack>
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.approvedBy ?? '-'}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.approvedAt ?? '-'}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.events.deliveries}
      </TableCell>
      <TableCell
        variant='body'
      >{props.events.incidents}

      </TableCell>
      <TableCell
        variant='body'
      >
        {props.events.inspections}
      </TableCell>
      <TableCell
        variant='lastRounded'

      >
        {props.events.events}
      </TableCell>
    </TableRow>
  );
};
